import { SVGProps } from 'react';

const SelectorIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    {...props}
  >
    <path
      d="M12.6608 6.32971L15.1208 8.78971C15.5108 9.17971 16.1408 9.17971 16.5308 8.78971C16.9208 8.39971 16.9208 7.76971 16.5308 7.37971L13.3608 4.19971C13.2683 4.107 13.1584 4.03344 13.0374 3.98325C12.9164 3.93306 12.7868 3.90723 12.6558 3.90723C12.5248 3.90723 12.3951 3.93306 12.2741 3.98325C12.1532 4.03344 12.0433 4.107 11.9508 4.19971L8.78078 7.37971C8.39078 7.76971 8.39078 8.39971 8.78078 8.78971C9.17078 9.17971 9.80078 9.17971 10.1908 8.78971L12.6608 6.32971ZM12.6608 18.6697L10.2008 16.2097C10.1083 16.117 9.99839 16.0434 9.87741 15.9932C9.75644 15.9431 9.62675 15.9172 9.49578 15.9172C9.36481 15.9172 9.23512 15.9431 9.11415 15.9932C8.99317 16.0434 8.88329 16.117 8.79078 16.2097C8.40078 16.5997 8.40078 17.2297 8.79078 17.6197L11.9608 20.7997C12.3508 21.1897 12.9808 21.1897 13.3708 20.7997L16.5408 17.6297C16.9308 17.2397 16.9308 16.6097 16.5408 16.2197C16.4483 16.127 16.3384 16.0534 16.2174 16.0032C16.0964 15.9531 15.9668 15.9272 15.8358 15.9272C15.7048 15.9272 15.5751 15.9531 15.4541 16.0032C15.3332 16.0534 15.2233 16.127 15.1308 16.2197L12.6608 18.6697Z"
      fill="#6B7280"
    />
  </svg>
);

export default SelectorIcon;
